<template>
    <div class="sidebar-tab-wrapper">
        <div class="sidebar-tab" :class="{'card-on-mobile': card_on_mobile || tab_on_mobile, 'no-top-spacement': title === '' && description === ''}" v-if="(!on_tab && !isMobile) || on_tab === current_tab || !isMobile || (tab_on_mobile && isMobile && $route.params.tab === on_tab) || (card_on_mobile && !on_tab && isMobile)">
            <div class="sidebar-tab-header" v-if="title !== ''">
                <i class="tw-text-lg tw-pr-3 tw-pt-px tw-mt-px" :class="[icon_type, 'fa-' + icon, icon_color_class]"></i>
                <h3 class="tw-font-semibold tw-text-base tw-flex-1">{{ title }}</h3>
                <slot name="header-actions"></slot>
            </div>
            <p class="form-card-description tw-text-sm tw--mt-3" v-if="description !== ''" v-html="description"></p>
            <slot></slot>
        </div>
        <template v-if="tab_on_mobile && isMobile">
            <portal to="tab-menu">
                <div class="tab-menu-item">
                    <router-link :to="{name: 'groups.show', params: { group_slug: $route.params.group_slug, tab: on_tab}}" class="menu-item" :class="{'secondary-c': $route.params.tab === on_tab}">
                        <i :class="[icon_type, 'fa-' + icon]"></i>
                        {{ title }}
                    </router-link>
                </div>
            </portal>
        </template>
    </div>
</template>

<script>
    import TabMenu from '../../mixins/v2/TabMenu';
    import { mapState } from 'vuex';
    
    export default {
        name: 'FormSidebarTab',

        mixins: [TabMenu],

        props: {
            icon: {
                type: String,
            },
            icon_type: {
                type: String,
                default: 'far',
            },
            icon_color_class: {
                type: String,
                default: '',
            },
            title: {
                type: String,
                default: '',
            },
            description: {
                type: String,
                default: '',
            },
            card_on_mobile: {
                type: Boolean,
                default: false,
            },
            tab_on_mobile: {
                type: Boolean,
                default: false,
            },
            on_tab: {
                default: false,
            },
        },

        computed: {
            ...mapState(['screen_width']),

            isMobile() {
                return this.screen_width <= 767;
            },
        },
    };
</script>

<style lang="scss">
    .sidebar-tab-wrapper {
        .sidebar-tab {
            @apply tw-pt-8 tw-mt-3 tw-border-t tw-border-gray-100 tw-hidden;

            .sidebar-tab-header {
                @apply tw-flex tw-items-center tw-mb-8;

                i {
                    width: 30px;
                }
            }

            .switch-wrapper {
                &.vertical {
                    .switch-label-wrapper {
                        @apply tw-mb-3;

                        label {
                            @apply tw-font-semibold;
                        }
                    }
                }
            }

            .input-time {
                @apply tw-bg-white tw-shadow-card #{!important};
                color: #333 !important;

                i {
                    @apply tw-text-base #{!important};
                    top: 1.3rem !important;
                    transform: none !important;
                }

                &:hover {
                    background: #fdfdfd !important;
                }
            }

            .trophy-picker-wrapper {
                left: -6px;
                top: calc(100% + 10px);
            }

            @screen md {
                @apply tw-block;
            }

            &.card-on-mobile {
                @apply tw-block;

                @media(max-width: 767px) {
                    @apply tw-rounded-lg tw-bg-white tw-flex tw-flex-col tw-mb-6 tw-p-5 tw-w-full;
                    box-shadow: 0 1px 3px #00000029;

                    .sidebar-tab-header {
                        @apply tw-flex tw-items-center tw-pb-5 tw-border-b tw-border-gray-0 tw-mb-4;

                        i {
                            @apply tw-mr-3 tw-text-lg tw-w-auto tw-p-0 tw-pt-px;
                        }

                        h3 {
                            @apply tw-font-semibold;
                        }
                    }
                }
            }

            &.no-top-spacement {
                @apply tw-pt-3 tw-mt-2;
            }
        }

        &:first-of-type {
            .sidebar-tab {
                @apply tw-border-0 tw-mt-0 tw-pt-0;

                @media(max-width: 767px) {
                    @apply tw-pt-5;
                }
            }
        }
    }
</style>
